/**
 * Created by mohameds on 17/7/19.
 */
import {
  LOG_OUT, SET_INDIVIDUAL_PAGE_DATA, ALL_PAGE_POSITION, UPDATE_APP_VERSION,
  FIRST_TIME_RELOAD
} from './ActionTypes'
import AgencyMonitorService from "../services/AgencyMonitorService";
import {getUser} from '../utils/TokenManager';


const IndividualPageData = (pageData) => ({
  type: SET_INDIVIDUAL_PAGE_DATA,
  pageData
});

const pagePosition = (pagePosition) => ({
  type: ALL_PAGE_POSITION,
  pagePosition
});

const updateVersion = (version) => ({
  type: UPDATE_APP_VERSION,
  version
});

const logOutSuccess = () => ({type: LOG_OUT});

const firstTimeReload = () => ({type: FIRST_TIME_RELOAD});


export const handleFirstTimeReload = () => (
  async(dispatch) => {
    try {
      dispatch(firstTimeReload());
      return true;
    } catch (error) {
      console.log(error);
    }
    return false;
  }
);

//Get all individual page
export const getIndividualPageData = (pageObj) =>(
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.getPageData(pageObj);

      if (getUser()['app-version'] != result.headers['app-version']) {
        dispatch(updateVersion(result.headers['app-version']));
        window.location.reload(true);
      }
      if (200 === result.status) {
        dispatch(IndividualPageData(result.data));
        return true
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);

export const getMonitorPageList = (userId) => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.getMonitorPageList();
      
      if (200 === result.status) {
        dispatch(pagePosition(result.data));
        return true
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);



// WEBPACK FOOTER //
// ./src/actions/AgencyMonitorPageAction.js